import { render } from "./Rules.vue?vue&type=template&id=9d34bcb4&scoped=true&ts=true"
import script from "./Rules.vue?vue&type=script&lang=ts"
export * from "./Rules.vue?vue&type=script&lang=ts"

import "./Rules.vue?vue&type=style&index=0&id=9d34bcb4&scoped=true&lang=scss"
import "./Rules.vue?vue&type=style&index=1&id=9d34bcb4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d34bcb4"]])

export default __exports__